import { render, staticRenderFns } from "./tdAssignmentNameLink.vue?vue&type=template&id=27f4be5e&scoped=true"
import script from "./tdAssignmentNameLink.vue?vue&type=script&lang=js"
export * from "./tdAssignmentNameLink.vue?vue&type=script&lang=js"
import style0 from "./tdAssignmentNameLink.vue?vue&type=style&index=0&id=27f4be5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4be5e",
  null
  
)

export default component.exports